import { apiCall } from '.';
import { RequestPasswordResetDto, ResendVerificationDto, ResetPasswordDto, SigninDto, SignupDto, VerifyEmailDto } from '../interfaces';

export const signupApi = (payload: SignupDto) => {
  return apiCall(false).post('/auth/signup', payload);
};

export const signinApi = (payload: SigninDto) => {
  return apiCall(false).post('/auth/signin', payload);
};

export const verifyEmailApi = (payload: VerifyEmailDto) => {
  return apiCall(false).post('/auth/confirm-email', payload);
};

export const resendVerificationApi = (payload: ResendVerificationDto) => {
  return apiCall(false).post('/auth/resend-email-confirmation', payload);
};

export const resetPasswordRequestApi = (payload: RequestPasswordResetDto) => {
  return apiCall(false).post('/auth/forgot-password', payload);
};

export const resetPasswordApi = (payload: ResetPasswordDto) => {
  return apiCall(false).post('/auth/reset-password', payload);
};
